import { TrendingHazardDTO } from '@hazadapt-git/public-core-base'
import { Typography } from '@mui/material'
import React, { FC } from 'react'

import { customDarkBlueColor, useStyles } from '../../lib/styles/universal'
import { useWindowSizeUp } from '../../lib/utils'
import {
    LocalContentTeaser,
    PanelProps,
    WhenToCall911ItemProps,
} from '../molecules'
import {
    HomePageFooter,
    PanelGrid,
    TrendingHazardItemList,
    WhenToCall911View,
} from '../organisms'

interface HomePageTemplateProps {
    trendingHazards: TrendingHazardDTO[]
    trendingHazardsError: boolean
    panels: PanelProps[]
    whenToCall911Items: WhenToCall911ItemProps[]
    loading: boolean
    onTrendingHazardPress(hazard_id: number): void
    hasLoco: boolean
    locoEnabled: boolean
    locationAvailable: boolean | undefined
    onGoToLocalContent(): void
}

export const HomePageTemplate: FC<HomePageTemplateProps> = (
    props: HomePageTemplateProps
) => {
    const { classes } = useStyles()
    const mediumWindowOrLarger = useWindowSizeUp('md')

    return (
        <div className={classes.page}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    alignItems: 'flex-start',
                    paddingBottom: mediumWindowOrLarger ? '4rem' : '0rem',
                }}
            >
                {mediumWindowOrLarger && (
                    <>
                        <Typography
                            variant={'h1'}
                            component="h1"
                            textAlign="left"
                            color={customDarkBlueColor}
                            paddingLeft="1rem"
                        >
                            Welcome
                        </Typography>
                        <Typography
                            textAlign="left"
                            color={customDarkBlueColor}
                            paddingLeft="1rem"
                        >
                            Life comes with hazards. We'll help you adapt.
                        </Typography>
                    </>
                )}
            </div>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: mediumWindowOrLarger
                        ? 'minmax(0, 1fr) minmax(0, 1fr)'
                        : 'minmax(0, 1fr)',
                    width: '100%',
                    minWidth: 0,
                }}
            >
                <div
                    style={{
                        width: '100%',
                        minWidth: 0,
                        boxSizing: 'border-box',
                        padding: '1rem 1rem 3rem 1rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2rem',
                    }}
                >
                    <TrendingHazardItemList
                        data={props.trendingHazards}
                        showErrorText={props.trendingHazardsError}
                        onPress={props.onTrendingHazardPress}
                        loading={props.loading}
                    />
                    <PanelGrid
                        id="home-panel-grid"
                        panels={props.panels}
                        rounded={mediumWindowOrLarger}
                    />
                </div>
                <div
                    style={{
                        width: '100%',
                        minWidth: 0,
                        boxSizing: 'border-box',
                        padding: '1rem 1rem 3rem',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        gap: '1rem',
                    }}
                >
                    {props.locationAvailable &&
                        props.locoEnabled &&
                        !props.loading && (
                            <LocalContentTeaser
                                hasLoco={props.hasLoco}
                                locoEnabled={props.locoEnabled}
                                locationAvailable={!!props.locationAvailable}
                                onGoToLocalContent={props.onGoToLocalContent}
                            />
                        )}
                    <WhenToCall911View data={props.whenToCall911Items} />
                </div>
            </div>
            <HomePageFooter />
        </div>
    )
}
